import { Api } from 'models/services/api';
import { DeleteBusinessCategoryQuery } from 'models/services/graphql';

import { BusinessCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteBusinessCategory($id: ID!) {
    ${DeleteBusinessCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteBusinessCategory: BusinessCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteBusinessCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };